export default {
  tiposCertificado: {
    "totalPages": 0,
    "totalItems": 0,
    "items": [
      {
        "id": "",
        "nome": "",
        "descricao": "",
        "acessivelClientes": true
      },
    ]
  }
}
